export function FloatFooter() {
  return (
    <>
      <footer className="backdrop-blur-sm bg-white/30 fixed bottom-0 text-center text-xs lg:text-base w-full ">
        <div className="text-grayP py-2 font-walsheim tracking-tighter">
          Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA registrada
          en Colombia con NIT: 901.582.748-5
        </div>
      </footer>
    </>
  );
}
